import React from "react";
import { NavLink } from "react-router-dom";
import PagesEndPoints from "../../utilities/constants/PagesEndpoints";
import { FileQuestion, Home, ArrowRight } from "lucide-react";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center max-w-md mx-auto">
        <div className="flex justify-center mb-8">
          <div className="p-4 bg-indigo-100 dark:bg-indigo-900/30 rounded-full">
            <FileQuestion className="w-16 h-16 text-indigo-600 dark:text-indigo-400" />
          </div>
        </div>

        <p className="text-base font-semibold text-indigo-600 dark:text-indigo-400">
          404 Error
        </p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-slate-900 dark:text-white sm:text-5xl">
          Page not found
        </h1>
        <p className="mt-6 text-base leading-7 text-slate-600 dark:text-slate-400">
          Sorry, we couldn’t find the page you’re looking for. It might have
          been moved or deleted.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <NavLink
            to={PagesEndPoints.HOME_PAGE_URL}
            className="rounded-full bg-indigo-600 px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-indigo-500/30 hover:bg-indigo-500 hover:shadow-indigo-500/50 transition-all flex items-center gap-2"
          >
            <Home className="w-4 h-4" />
            Go back home
          </NavLink>
          <NavLink
            to={PagesEndPoints.CONTACT_PAGE_URL}
            className="text-sm font-semibold text-slate-900 dark:text-white flex items-center gap-2 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
          >
            Contact support <ArrowRight className="w-4 h-4" />
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
